import type { EarlyStageVerificationStatus } from "../api/earlyStageMembershipApi";

function storageKey(objectId: string, rejectedAt: string): string {
  return `esRejectionAck_${objectId}_${rejectedAt}`;
}

/** True when the rejection notice should still be shown (browser-local ack only). */
export function isEarlyStageRejectionNoticeVisible(
  status: EarlyStageVerificationStatus | null | undefined,
  objectId?: string | null,
): boolean {
  if (!status?.showRejectionNotice) return false;
  const oid = objectId?.trim();
  if (!oid) return true;

  const rejectedAt = status.rejectedAt?.trim();
  if (!rejectedAt) return true;

  try {
    return localStorage.getItem(storageKey(oid, rejectedAt)) !== "1";
  } catch {
    return true;
  }
}

export function acknowledgeEarlyStageRejectionNoticeLocal(
  objectId: string,
  rejectedAt: string,
): void {
  try {
    localStorage.setItem(storageKey(objectId.trim(), rejectedAt.trim()), "1");
  } catch {
    /* private browsing / storage full */
  }
}
